<h2 mat-dialog-title class="sk-dialog-title">
  <mat-icon>bolt</mat-icon> Spontan-Einsatz anlegen
</h2>

<mat-dialog-content class="se-content">
  <p class="sk-muted se-hint">
    Du teilst dich selbst ein. Ohne gewählten Auftrag landet der Einsatz im Sammel-Auftrag
    „Spontane Einsätze" des Stammkunden – der Bauleiter sieht ihn in der Übersicht.
  </p>

  <div class="section-label"><mat-icon class="sk-inline-icon">badge</mat-icon> Für welchen Stammkunden?</div>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Stammkunde</mat-label>
    <mat-select [(ngModel)]="customerId" (selectionChange)="onCustomerChange()" required>
      <mat-option *ngFor="let c of data.customers" [value]="c.id">{{c.name}}</mat-option>
    </mat-select>
    <mat-icon matPrefix>badge</mat-icon>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width" *ngIf="auftraege.length > 0">
    <mat-label>Auftrag (optional)</mat-label>
    <mat-select [(ngModel)]="auftragId" (selectionChange)="onAuftragChange()">
      <mat-option [value]="null">— Spontan (Sammel-Auftrag) —</mat-option>
      <mat-option *ngFor="let a of auftraege" [value]="a.id">{{a.title}}</mat-option>
    </mat-select>
    <mat-icon matPrefix>assignment</mat-icon>
  </mat-form-field>

  <div class="section-label"><mat-icon class="sk-inline-icon">schedule</mat-icon> Wann?</div>

  <div class="form-row">
    <mat-form-field appearance="outline" class="date-field">
      <mat-label>Datum</mat-label>
      <input matInput type="date" [(ngModel)]="startDate" required>
    </mat-form-field>
    <mat-form-field appearance="outline" class="time-field">
      <mat-label>Von</mat-label>
      <input matInput type="time" [(ngModel)]="startTime" required>
    </mat-form-field>
    <mat-form-field appearance="outline" class="time-field">
      <mat-label>Bis</mat-label>
      <input matInput type="time" [(ngModel)]="endTime" required>
    </mat-form-field>
  </div>

  <div class="sk-filter-chips preset-row">
    <button type="button" class="sk-filter-chip" [class.active]="isTimes('07:00','16:00')"
            (click)="setTimes('07:00','16:00')">Ganztag 07–16</button>
    <button type="button" class="sk-filter-chip" [class.active]="isTimes('07:00','12:00')"
            (click)="setTimes('07:00','12:00')">Vormittag 07–12</button>
    <button type="button" class="sk-filter-chip" [class.active]="isTimes('12:00','17:00')"
            (click)="setTimes('12:00','17:00')">Nachmittag 12–17</button>
  </div>

  <div class="section-label"><mat-icon class="sk-inline-icon">location_on</mat-icon> Was &amp; Wo</div>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Titel / Tätigkeit</mat-label>
    <input matInput [(ngModel)]="title" placeholder="z.B. Reparatur Baustelle Nord">
  </mat-form-field>

  <!-- Bau/Einsatzort: bestehende Orte des Kunden als Vorschlag, Freitext bleibt
       möglich (ein neuer Bau muss nicht vorher angelegt werden). -->
  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Bau / Einsatzort</mat-label>
    <!-- focus UND click: so erscheint die vollständige Liste auch beim erneuten
         Anklicken eines bereits fokussierten Feldes. -->
    <input matInput [(ngModel)]="location" [matAutocomplete]="bauAuto"
           (focus)="onLocationFocus()" (click)="onLocationFocus()"
           (ngModelChange)="onLocationInput($event)"
           placeholder="z.B. Bau44" autocomplete="off">
    <mat-icon matPrefix>location_on</mat-icon>
    <mat-autocomplete #bauAuto="matAutocomplete" panelClass="bau-autocomplete-panel">
      <mat-option *ngFor="let l of gefilterteLocations" [value]="l">{{ l }}</mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width" *ngIf="workers.length > 0">
    <mat-label>Arbeiter (ohne Login)</mat-label>
    <mat-select [(ngModel)]="workerIds" multiple>
      <mat-option *ngFor="let w of workers" [value]="w.id">{{w.name}}</mat-option>
    </mat-select>
    <mat-icon matPrefix>construction</mat-icon>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Notizen</mat-label>
    <textarea matInput [(ngModel)]="notes" rows="2"></textarea>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()" [disabled]="saving">Abbrechen</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="saving || !valid">
    <mat-icon *ngIf="!saving">bolt</mat-icon> Anlegen
  </button>
</mat-dialog-actions>
